import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store"


Vue.use(Router)


// import Layout from '@/layout'

export const constantRoutes = store.state.user.route



const createRouter = () => new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()


export function resetRouter() {
    const newRouter = createRouter()


    router.matcher = newRouter.matcher // reset router
}


export default router